var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-erpsku"},[_c('TableList',_vm._b({on:{"on-check-change":_vm.handleCheck}},'TableList',_vm.getTableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }